import { render } from "./jobtab.vue?vue&type=template&id=c16f8c5e"
import script from "./jobtab.vue?vue&type=script&lang=js"
export * from "./jobtab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__